export default __webpack_public_path__ + "static/media/Libro.d2f7911e.png";